import type { BillingError, BillingPort, ClientKind, PurchaseResult } from "./types";

const unavailable = (): BillingError => ({ code: "unavailable" });
const noop = () => () => undefined;

/**
 * 모의 결제는 로컬 빌드(VITE_BILLING=mock)에서만 — 앱(AC0-227)·웹 토스(AC0-302) 공통. 스테이지 빌드(`--mode dev|prod`: deploy.sh·ota-release.sh·build-*.sh)는
 * VITE_BILLING 과 무관하게 실결제(앱 = 네이티브, 웹 = 토스 결제창) — dev 서버도 PLAY·APPSTORE_VERIFY=live 라 모의 증빙은 402 가 된다(dev-web-0.0.20 OTA 사고).
 */
export const isMockBilling = (env: { MODE: string; VITE_BILLING?: string }) => env.MODE !== "dev" && env.MODE !== "prod" && env.VITE_BILLING === "mock";

/**
 * 모의 결제(1.15): 플러그인 없이 `mock:<productId>` 증빙을 즉시 돌려준다. 서버는 PLAY_VERIFY·APPSTORE_VERIFY=mock 에서만 받는다.
 * iOS 는 apple 증빙(→ /purchases/apple), 그 밖은 google 증빙(→ /purchases/google). 앱은 로컬 빌드에서만 선택된다(index.ts).
 */
export const createMockBilling = (clientKind: ClientKind): BillingPort => ({
  async getStorefront() {
    return "KR";
  },
  // 모의 스토어엔 가격이 없다 → 전부 "있음", 가격은 서버 값(priceString null)
  async getProducts(productIds) {
    return productIds.map((productId) => ({ productId, priceString: null, currency: null }));
  },
  async purchase(productId): Promise<PurchaseResult> {
    const token = `mock:${productId}`;
    return clientKind === "ios" ? { store: "apple", productId, signedTransaction: token, transactionId: token } : { store: "google", productId, purchaseToken: token };
  },
  async finish() {},
  async getPendingPurchases() {
    return [];
  },
  onPurchaseUpdated: noop,
});

/** prod 웹: 상점 자체가 Play 랜딩이라 호출되지 않는다. 호출되면 unavailable. */
export const webBilling: BillingPort = {
  async getStorefront() {
    return null;
  },
  async getProducts() {
    return [];
  },
  async purchase() {
    throw unavailable();
  },
  async finish() {},
  async getPendingPurchases() {
    return [];
  },
  onPurchaseUpdated: noop,
};
